import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SearchListComponent } from '../../address/search-list/search-list.component';
import { countryReference } from 'src/app/utils/constants/strings';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AddressService } from '../../address/service/address/address.service';
import { getCountryNameByCountryCode, postalCodePatternValidation } from 'src/app/utils/utils';
import { AddressEmailAlertComponent } from '../../address/address-email-alert/address-email-alert.component';
import { SnackBarService } from 'src/app/shared/snack-bar/services/snack-bar.service';
import { basicSnackBarConfig } from 'src/app/utils/default-configs/configuration';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
@Component({
  selector: 'app-receiver',
  templateUrl: './receiver.component.html',
  styleUrls: ['./receiver.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReceiverComponent implements OnInit, OnChanges {
  @Input() shipmentForm: FormGroup;
  @Input() receiverAddress = {};
  @Input() isRecPostalValidated: boolean;
  @Input() shipmentStatus: string;
  @Input() countryCode: string;
  CountryCode: string;
  preAlertEmailsData: any;
  list = [];
  filteredCountry = countryReference;
  cityList = [];
  isPostalCodeValid: boolean = true;
  isCityValid: boolean = true;
  isPostalCodeReq: boolean;
  showEmailAdd: boolean;
  validPostalCodeCityname: string;
  @Output() myRecUpdatedStatus = new EventEmitter<boolean>();
  constructor(
    private dialog: MatDialog,
    private addressService: AddressService,
    private _fb: FormBuilder,
    private snackBarService: SnackBarService,
    private behaviourService: BehaviourService
  ) {}

  ngOnInit() {
    this.list = countryReference;
    this.recCountrySearchInitialise();
    this.recCitySearchInitialise();
    this.recPinCodeSearchInitialise();
    this.getNotfStatus();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'shipmentStatus':
            this.shipmentStatus = String(changes[propName].currentValue);
            break;

          case 'countryCode':
            this.countryCode = changes[propName].currentValue;
            if (this.countryCode) {
              this.recCitySearchInitialise();
              this.recPinCodeSearchInitialise();
            }
            break;

          case 'receiverAddress':
            this.receiverAddress = changes[propName].currentValue;
            break;
        }
      }
    }
  }
  recCountrySearchInitialise() {
    this.shipmentForm
      .get('receiverDetails')
      .get('receiverCountryName')
      .valueChanges.subscribe(newValue => {
        this.list = this.filteredCountry.filter(
          value => value?.name.toLowerCase().indexOf(newValue?.trim().toLowerCase()) === 0
        );
      });
  }
  getNotfStatus() {
    this.shipmentForm
      .get('shipmentNotification')
      .valueChanges.subscribe(val => (this.showEmailAdd = val));
  }

  recCitySearchInitialise() {
    this.shipmentForm.controls.receiverDetails
      .get('receiverCityName')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (!this.shipmentStatus.includes('Manifest')) {
          const currCity = this.cityList.some(con => con.city == newValue.trim());
          if (!currCity) {
            if (newValue.trim().length >= 3) {
              this.addressService
                .getPostalCodeServiceableArea(
                  this.shipmentForm.get('receiverDetails').get('receiverCountryCode').value,
                  newValue.trim(),
                  ''
                )
                .subscribe((response: any) => {
                  const currCountryCode = this.shipmentForm
                    .get('receiverDetails')
                    .get('receiverCountryCode').value;

                  if (currCountryCode !== undefined) {
                    this.isPostalCodeReq = this.list.find(
                      con => con.code === currCountryCode.toUpperCase()
                    ).isPostalCodeServiceAvailable;
                  }
                  if (!this.isPostalCodeReq) {
                    this.shipmentForm.get('receiverDetails').get('receiverPostalCode').setValue('');
                    this.shipmentForm.get('receiverDetails').get('receiverPostalCode').disable();
                  } else {
                    this.shipmentForm.get('receiverDetails').get('receiverPostalCode').enable();
                  }
                  this.cityList = response?.postalLocationList;
                  if (this.cityList.length > 0) {
                    if (
                      this.shipmentForm.get('receiverDetails').get('receiverCityName').value != ''
                    ) {
                      //city is valid if either api with city input gives a response or if the postal code contain the city name
                      this.isCityValid =
                        this.cityList.some(con => con.city == newValue.trim().toUpperCase()) ||
                        this.validPostalCodeCityname.trim().toUpperCase() ==
                          newValue.trim().toUpperCase();

                      const statusVal = this.isCityValid && this.isPostalCodeValid;
                      this.myRecUpdatedStatus.emit(statusVal);
                    }
                  } else {
                    this.isCityValid = false;
                    const statusVal = this.isCityValid && this.isPostalCodeValid;
                    this.myRecUpdatedStatus.emit(statusVal);
                  }
                });
            }
          } else {
            this.isCityValid = true;
            const statusVal = this.isCityValid && this.isPostalCodeValid;
            this.myRecUpdatedStatus.emit(statusVal);
          }
        }
      });
  }

  recPinCodeSearchInitialise() {
    this.shipmentForm.controls.receiverDetails
      .get('receiverPostalCode')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (!this.shipmentStatus.includes('Manifest')) {
          if (
            this.shipmentForm.get('receiverDetails').get('receiverCountryCode').value == 'CA' ||
            this.shipmentForm.get('receiverDetails').get('receiverCountryCode').value == 'GB'
          ) {
            newValue = postalCodePatternValidation(
              this.shipmentForm.get('receiverDetails').get('receiverCountryCode').value,
              newValue
            );
          }
          const currPostalCode = this.cityList.some(con => con.postalCode == newValue.trim());
          if (!currPostalCode) {
            if (newValue.trim().length >= 3) {
              this.addressService
                .getPostalCodeServiceableArea(
                  this.shipmentForm.get('receiverDetails').get('receiverCountryCode').value,
                  '',
                  newValue.trim()
                )
                .subscribe((response: any) => {
                  this.cityList = response?.postalLocationList;

                  if (this.cityList.length > 0) {
                    if (
                      this.isPostalCodeReq &&
                      this.shipmentForm.get('receiverDetails').get('receiverPostalCode').value != ''
                    ) {
                      this.isPostalCodeValid = this.cityList.some(
                        con => con.postalCode == newValue.trim()
                      );

                      const statusVal = this.isCityValid && this.isPostalCodeValid;
                      this.myRecUpdatedStatus.emit(statusVal);
                    }
                  } else {
                    this.isPostalCodeValid = false;
                    const statusVal = this.isCityValid && this.isPostalCodeValid;
                    this.myRecUpdatedStatus.emit(statusVal);
                  }
                  //find city name corresponding to valid postal code
                  if (this.isPostalCodeValid) {
                    this.validPostalCodeCityname = this.cityList.find(
                      con => con.postalCode == newValue.trim()
                    ).city;
                  }
                });
            }
          } else {
            this.isPostalCodeValid = true;
            this.cityList = this.cityList.filter(
              value => value?.postalCode.indexOf(newValue) === 0
            );
            const statusVal = this.isCityValid && this.isPostalCodeValid;
            this.myRecUpdatedStatus.emit(statusVal);
          }
        }
      });
  }

  selectionChanged(eventVal: string) {
    if (eventVal != '') {
      this.CountryCode = this.list.find(con => con.name === eventVal).code;
      this.shipmentForm
        .get('receiverDetails')
        .get('receiverCountryCode')
        .setValue(this.CountryCode);
      this.shipmentForm.get('receiverDetails').get('receiverPostalCode').setValue('');
      this.shipmentForm.get('receiverDetails').get('receiverCityName').setValue('');
      this.shipmentForm.get('receiverDetails').get('receiversuburb').setValue('');
      this.addressService
        .getPostalCodeServiceableArea(
          this.shipmentForm.get('receiverDetails').get('receiverCountryCode').value,
          '',
          ''
        )
        .subscribe((response: any) => {
          this.cityList = response?.postalLocationList;
        });
      this.isPostalCodeReq = this.list.find(
        con => con.code === this.CountryCode
      ).isPostalCodeServiceAvailable;
      if (!this.isPostalCodeReq) {
        this.shipmentForm.get('receiverDetails').get('receiverPostalCode').disable();
        this.isPostalCodeValid = true;
      } else {
        this.shipmentForm.get('receiverDetails').get('receiverPostalCode').enable();
      }
    } else {
      this.shipmentForm.get('receiverDetails').get('receiverCountryCode').setValue('');
    }
    if (this.shipmentForm.get('receiverDetails').get('receiverCountryCode').value === 'US') {
      this.behaviourService.sendEvent({
        type: 'receiver',
        calculate: true,
        ...this.shipmentForm?.value?.invoiceDetails,
      });
    } else {
      this.behaviourService.sendEvent({ type: 'receiver', calculate: false });
    }
  }

  openAddress(openedFrom) {
    const dialogRef = this.dialog.open(SearchListComponent, {
      data: {
        openedFrom,
      },
      maxHeight: '70vh',
      maxWidth: '90vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.shipmentForm.controls.receiverDetails.patchValue(result?.address_details);
      this.preAlertEmailsData = result?.preAlertEmails ? result.preAlertEmails : [];
      const shipmentNotificationData = result.shipmentNotification;
      this.receiverAddress = result;
      this.patchPreAlertNew(this.preAlertEmailsData);
      this.shipmentForm.controls.shipmentNotification.patchValue(shipmentNotificationData);
      //TODO : Needs to refined fixed for urgent replace of country
      this.shipmentForm.controls.receiverDetails.patchValue({
        receiverCountryName: getCountryNameByCountryCode(result.address_details.receiverCountryCode)
          .name,
      });

      if (result != '') {
        this.shipmentForm.get('receiverDetails').get('receiverCityName').markAsDirty();
      }
    });
  }

  selectionCityChanged(event, item) {
    this.isRecPostalValidated = true;
    if (!item?.postalCode) {
      this.shipmentForm.get('receiverDetails').get('receiverPostalCode').disable();
      if (event.isUserInput) {
        if (item?.cityDistrict) {
          this.shipmentForm
            .get('receiverDetails')
            .get('receiversuburb')
            .setValue(item?.cityDistrict);
        }
      }
    } else {
      this.shipmentForm.get('receiverDetails').get('receiverPostalCode').enable();
      if (event.isUserInput) {
        this.shipmentForm
          .get('receiverDetails')
          .get('receiverPostalCode')
          .setValue(item?.postalCode);
      }
    }
  }

  selectionPincodeChanged(event, item) {
    this.isRecPostalValidated = true;
    if (event.isUserInput) {
      this.shipmentForm.get('receiverDetails').get('receiverCityName').setValue(item?.city);
      this.isCityValid = true;
    }
  }

  newPreAlertMsg(): FormGroup {
    return this._fb.group({
      typeCode: 'email',
      receiverId: '',
      bespokeMessage: '',
    });
  }

  patchPreAlertNew(preAlertEmailsData) {
    if (preAlertEmailsData.length > 0) {
      (this.shipmentForm.get('preAlertEmails') as FormArray).clear();
      preAlertEmailsData.forEach(alertMsg => {
        const alertMsgGrp = this.newPreAlertMsg();
        alertMsgGrp.patchValue(alertMsg);
        (this.shipmentForm.get('preAlertEmails') as FormArray).push(alertMsgGrp);
      });
    } else {
      (this.shipmentForm.get('preAlertEmails') as FormArray).clear();
    }
  }

  openPreAlertSetting() {
    const shipmentDetailsCreateDialogRef = this.dialog.open(AddressEmailAlertComponent, {
      maxHeight: '60vh',
      maxWidth: '60vw',
      data: {
        openedFrom: 'receiverShipment',
        preAlertEmails: this.shipmentForm.get('preAlertEmails').value,
        shipmentForm: this.shipmentForm,
        receiverAddress: this.receiverAddress,
      },
    });
    shipmentDetailsCreateDialogRef.afterClosed().subscribe(result => {
      if (!result?.id) {
        this.patchPreAlertNew(result?.value);
      }
    });
  }
  showHideEmailAdd(checked: boolean) {
    let val:boolean;
    let preAlertEmailsData = [];
    
    if (checked) {
      // When checked, populate preAlertEmails if empty
      if (this.shipmentForm.get('preAlertEmails').value.length < 1) {
        const receiverEmail = this.shipmentForm.value.receiverDetails.receiverEmail;
        
        // Convert single email string to array format if it exists
        if (receiverEmail && receiverEmail.trim()) {
          preAlertEmailsData = [{
            typeCode: 'email',
            receiverId: receiverEmail,
            bespokeMessage: ''
          }];
          this.patchPreAlertNew(preAlertEmailsData);
        }
      }
    } else {
      // When unchecked, clear preAlertEmails
      this.patchPreAlertNew([]);
    }

    checked ? (val = true) : (val = false);
    this.savePreAlertEmail(val);
  }

  savePreAlertEmail(val) {
    this.showEmailAdd = val;
    this.receiverAddress['preAlertEmails'] = this.shipmentForm.value?.preAlertEmails;
    this.receiverAddress['shipmentNotification'] = val;
    const requestBody = this.receiverAddress;
    this.addressService.updateAddress(requestBody).subscribe({
      next: () => {
        this.snackBarService.createSnackBar(
          basicSnackBarConfig.addressComponentUpdate?.message,
          basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
          basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
          basicSnackBarConfig.addressComponentUpdate?.duration
        );
      },
    });
  }
  ngOnDestroy(): void {
    this.behaviourService.sendEvent(null);
  }
}
